import React from "react";
import "../css/Whyus.css";


function Whyus() {
  return ( 
    <section id="kami" class="why-us bg-white">
        <div class="title_whyus">
              <h1>
                <font class="text-o-color-1">Kenapa Kami</font>
              </h1>
        </div>
        <br/>
        <div class="container">
          <div class="row bg-white align-items-center">
            <div class="col-lg-4 o_colored_level content_title" style={{verticalAlign:'text-top',display:'flex'}}>
              <h4 class="color-primary" style={{textAlign: 'left'}}>
                <font class="text-o-color-1" style={{fontWeight:'bolder'}}>Harga</font>
                  <span style={{fontWeight:'bolder'}}>
                  </span>
                <br/>
                <font class="text-o-color-1" style={{fontWeight:'bolder'}}>Terjangkau</font>
              </h4>
            </div>
            <div class="col-lg-8 content1">
              <font face="Titillium Web, Arial" class="text-o-color-1">
                <span class="text-alpha">
                  <span>Kami mengutamakan harga yang sesuai dengan kantong anda, dengan pelayanan kami sudah menyediakan supir sebagai sarana penunjang perjalanan anda, sehingga tidak perlu lagi memikirkan jalan, arah dan biarlah perjalanan anda sekeluarga, rekan akan menjadi lebih berkualitas</span>
                </span>
              </font>
              
            
            </div>
          </div>
        </div>
        <br/>
        <div class="container" style={{borderBottom:'1px solid #330CCFFF'}}></div>
        <br/>
        <div class="container">
          <div class="row bg-white align-items-center">
            <div class="col-lg-4 o_colored_level content_title">
            <h4 class="color-primary" style={{textAlign: 'left'}}>
                <span style={{fontWeight:'bolder'}}>
                  <font class="text-o-color-1">Pelayanan</font>
                </span>
                <br/>
                <span style={{fontWeight:'bolder'}}>
                  <font class="text-o-color-1">Nyaman</font>
                </span>
                <b>
                </b>
              </h4>
            </div>
            <div class="col-lg-8 content2">
              <font face="Titillium Web, Arial" class="text-o-color-1">
                <span  class="text-alpha">
                  <span>Kami mengerti kebutuhan anda, dengan menyediakan system audio karaoke dapat mengubah suasana perjalanan anda lebih menyenangkan dan tidak telupakan bersama teman, keluarga, rekan kerja bahkan tamu sekalipun</span>
                </span>
              </font>
             
            </div>
          </div>
        </div>
       
     
    </section>
  );
}
   
export default Whyus;